import React from "react";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";
import { formatDate } from "helpers/DateHelper";
import { getTestPassedTitle } from "helpers/RequestTestsHelper";
import UploadedResults from "containers/testResult/UploadedResults";
import StatusBadge from "components/Badges/TestStatusBadge";
import { auditReportDownload } from "actions/battery/sar";

const UnderReviewViewSAR = ({
  show,
  request,
  testModule,
  auditReportDownload
}) => {
  if (!show) return null;

  const startDate = formatDate(testModule.actualstartdate);
  const endDate = formatDate(testModule.actualenddate);

  return (
    <div>
      <Table responsive className="ctia-table">
        <thead>
          <tr>
            <th>Audit Result</th>
            <th>Audit Status</th>
            <th>CRSL Version</th>
            <th>Audit Start Date</th>
            <th>Audit End Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {getTestPassedTitle(testModule.requesttestpassedstatusid, true)}
            </td>
            <td>
              <StatusBadge statusId={testModule.requestteststatusid} />
            </td>
            <td>{request.crslversion}</td>
            <td>{startDate}</td>
            <td>{endDate}</td>
          </tr>
        </tbody>
      </Table>
      <UploadedResults
        reports={testModule.reports}
        downloadHandler={auditReportDownload}
      />
    </div>
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps, {
  auditReportDownload
})(UnderReviewViewSAR);
